import { Box, Stack, useTheme } from "@mui/material"
import { rdsEvent_Dto } from "../../../interfaces/dtos/rdsEvent";
import { getEventDesc } from "../../../utils/commonUtils";
import dayjs from "dayjs";
import { useAppSelector } from "../../../redux/hooks";
import { rdsState } from "../../../redux/rds/rdsSlice";
import { eventStatusCodes, eventStatusDesc } from "../../shared/commonConstants";
import { rdsMeeting_Dto } from "../../../interfaces/dtos/rdsMeeting";

interface ScheduleCommonDetailsProps {
  event: rdsEvent_Dto;
  bettingPhase: string;
  suspended: boolean;
  meeting?: rdsMeeting_Dto;
}

export const ScheduleCommonDetails = ({
  event, bettingPhase, suspended, meeting
}: ScheduleCommonDetailsProps) => {

  const theme = useTheme();
  const rds = useAppSelector(rdsState);

  const eventStatus = rds.rdsEventStatuses.find((e) => e.id === event.id);
  const bettingSuspendedDesc = suspended ? "Betting Suspended" : "";

  const warningBroadcastStatuses = [eventStatusCodes.Void, eventStatusCodes.Abandon];
  const hasWarningBroadcast = warningBroadcastStatuses.includes(eventStatus?.status ?? '') ||
    warningBroadcastStatuses.includes(meeting?.status ?? '');

  const getBroadcastMessage = () => {
    if (warningBroadcastStatuses.includes(eventStatus?.status ?? '')) {
      return `Event ${eventStatusDesc(eventStatus?.status ?? '').toLowerCase()}`;
    } else if (warningBroadcastStatuses.includes(meeting?.status ?? '')) {
      return `Meeting ${eventStatusDesc(meeting?.status ?? '').toLowerCase()}`;
    } else {
      return eventStatus?.progressMessage;
    }
  }

  return (
    <Stack      
      direction="row"      
      sx={{ height: '80px', paddingTop: '20px', width: '100%', justifyContent: "space-between" }}
    >
      <Stack
        direction="column"
      >
        <Box id="betting-phase">
          {bettingPhase}
        </Box>
        <Box
          id="suspended-status"
          sx={{ color: suspended ? theme.palette.error.main : undefined }}
        >
          {bettingSuspendedDesc}
        </Box>
      </Stack>
      <Box sx={{ fontWeight: 'bold', textAlign: 'center' }}>
        <Box id="event-date">
          {`Race ${event.number} ${meeting?.description} ${dayjs(event.dateTime).format("DD/MM/YYYY")}`}
        </Box>
        <Box id="event-desc">
          {getEventDesc(event)}
        </Box>
      </Box>
      <Box
        id="broadcast-prompt"
        sx={{ color: hasWarningBroadcast ? theme.palette.error.main : undefined }}>
        {getBroadcastMessage()}
      </Box>
    </Stack>
  )
}
